import { toUtcAdjusted } from '@noor/lib';
import type { SlotListSearch } from '../model/list-params';

/** Query of `GET admin/bonus-periods`. */
export interface SlotListFilter {
  limit: number;
  skip: number;
}

/** Query of `GET admin/bonuses/reserves`. */
export interface SlotReservesFilter {
  limit: number;
  skip: number;
  search?: string | undefined;
  from_date: string;
  till_date: string;
  order_by_date: false;
  bonus_id: string;
}

export function buildSlotListFilter(search: SlotListSearch): SlotListFilter {
  return {
    limit: search.pageSize,
    skip: (search.page - 1) * search.pageSize,
  };
}

/**
 * Build the reserves query of one slot (cpanel `Content`): the day window with
 * the `+1 day` inclusive end, the (already debounced) search, newest-last
 * (`order_by_date: false`) and the slot id.
 */
export function buildSlotReservesFilter(
  search: SlotListSearch,
  slotId: string,
  term: string,
): SlotReservesFilter {
  return {
    limit: search.reservesPageSize,
    skip: (search.reservesPage - 1) * search.reservesPageSize,
    search: term === '' ? undefined : term,
    from_date: toUtcAdjusted(search.reserve_start_date).toISOString(),
    till_date: toUtcAdjusted(search.reserve_end_date).add(1, 'day').toISOString(),
    order_by_date: false,
    bonus_id: slotId,
  };
}
